// Add your JS customizations here


// FAQ Accordion
document.addEventListener('DOMContentLoaded', function() {
	var rankMathListItems = document.querySelectorAll('.rank-math-list-item');

	rankMathListItems.forEach(function(item) {
		item.addEventListener('click', function() {
			rankMathListItems.forEach(function(item) {
				item.classList.remove('active');
			});

			this.classList.add('active');
		});
	});
});
